<script>
    import FormSearchInput from '../../../../Pages/components/forms/FormSearchInput.vue';
    import Button from '../../../../Pages/components/buttons/Button.vue';
    import AddButton from "../../../../Pages/components/buttons/AddButton.vue";
    import FormModal from '../../../components/modals/FormModal.vue';
    import MultiSelect from "vue-multiselect";
    import FormDropdown from '../../../components/forms/FormDropdown.vue';
    import axios from 'axios';

    export default {
        components: {
            FormSearchInput,
            Button,
            AddButton,
            FormModal,
            MultiSelect,
            FormDropdown
        },        

        props: {
            isShowAssignButton: Boolean,
            isShowSearch: Boolean,
            workflowAssignees: Array,
            workflowTemplates: Array,
            renderAssignedWorkflows: Function
        },

        data() {
            return {
                searchValue: null,
                isShowAssignWorkflowModal: false,
                isAssignWorkflowSubmitButtonLoading: false,
                assignWorkflowSubmitButtonText: 'Assign',
                selectedAssignees: [],
                selectedTemplate: null,
                applyWorkflowErrors: {},
                alreadyAppliedAssignees: [],
                isReapplyLoadingArray: [],
                isDeleteLoadingArray: []
            }
        },
    
        methods: {
            searchFunc() {
                return false
            },
            searchInputTrigger() {
                this.$refs.searchClick.onClick()
            },
            showAssignWorkflowModal() {
                this.alreadyAppliedAssignees = []
                this.selectedAssignees = []
                this.selectedTemplate = null
                this.applyWorkflowErrors = {}
                this.isShowAssignWorkflowModal = true
            },
            hideAssignWorkflowModal() {
                this.isShowAssignWorkflowModal = false
            },
            asingeeOptionLabel(option) {
                return `${option.name}`
            },
            workflowTemplateOptionLabel(option) {
                return `${option.name}`
            },
            selectAssignee() {
                if(this.applyWorkflowErrors.assignees) {
                    this.applyWorkflowErrors.assignees = null
                }
            },
            selectTemplate() {
                if(this.applyWorkflowErrors.template) {
                    this.applyWorkflowErrors.template = null
                }
            },
            removeSelectedAssignees(value) {
                if(this.alreadyAppliedAssignees.length) {
                    let i = 0
                    this.alreadyAppliedAssignees = []
                    for (let item of this.selectedAssignees) {
                        if(value.id != item.id) {
                            this.alreadyAppliedAssignees[i] = item
                            i++
                        }
                    }
                }
            },
            managedAlreadyAssigneesList(alreadyAssigneeIds) {
                this.alreadyAppliedAssignees = []
                let i = 0
                for (let item of this.selectedAssignees) {
                    if(alreadyAssigneeIds.includes(item.id)) {
                        this.alreadyAppliedAssignees[i] = item
                        i++
                    }
                }
                this.selectedAssignees = this.alreadyAppliedAssignees
            },
            handleAssignWorkflowSubmit() {
                this.$refs.topProgress.start()
                this.isAssignWorkflowSubmitButtonLoading = true;
                this.assignWorkflowSubmitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`;
                let selectedAssignees = this.selectedAssignees
                let selectedTemplate = this.selectedTemplate
                axios.post(
                    route('tc-workflow-management.store'),
                    {
                        selectedAssignees,
                        selectedTemplate,
                        operationType: 'Assign'
                    }, {
                }).then(response => {
                    this.$toastr.s(response.data.message);
                    this.assignWorkflowSubmitButtonText = 'Assign';
                    this.isAssignWorkflowSubmitButtonLoading = false;
                    this.renderAssignedWorkflows()
                    if(response.data.alreadyAppliedAssigneeIds.length) {
                        this.managedAlreadyAssigneesList(response.data.alreadyAppliedAssigneeIds)
                    } else {
                        this.alreadyAppliedAssignees = []
                        this.selectedAssignees = []
                        this.selectedTemplate = null
                        this.applyWorkflowErrors = {}
                    }
                    this.$refs.topProgress.done()
                }).catch(err => {
                    this.renderAssignedWorkflows()
                    if(err.response.status == 422) {
                        this.applyWorkflowErrors = {
                            ...this.applyWorkflowErrors,
                            assignees: err.response.data.errors.selectedAssignees ? err.response.data.errors.selectedAssignees[0] : null,
                            template: err.response.data.errors.selectedTemplate ? err.response.data.errors.selectedTemplate[0] : null,
                        }
                    } else {
                        this.$toastr.e(err.response.data.message);
                    }
                    this.isAssignWorkflowSubmitButtonLoading = false;
                    this.assignWorkflowSubmitButtonText = 'Assign';
                    this.$refs.topProgress.done()
                });
            },

            handleReapplyDeleteWorkflow(type, userId) {
                if(confirm('Are you sure you want to ' + type + '?')) {
                    if(type === 'Reapply') {
                        this.$set(this.isReapplyLoadingArray, userId, true)
                    } else {
                        this.$set(this.isDeleteLoadingArray, userId, true)
                    }
                    this.$refs.topProgress.start()
                    this.isAssignWorkflowSubmitButtonLoading = true;
                    let selectedAssignees = this.selectedAssignees
                    let selectedTemplate = this.selectedTemplate
                    axios.post(
                        route('tc-workflow-management.store'),
                        {
                            selectedAssignees,
                            selectedTemplate,
                            operationType: type,
                            selectedUserId: userId
                        }, {
                    }).then(response => {
                        this.$toastr.s(response.data.message);
                        this.assignWorkflowSubmitButtonText = 'Assign';
                        this.isAssignWorkflowSubmitButtonLoading = false;
                        this.renderAssignedWorkflows()
                        this.managedAlreadyAssigneesList(response.data.alreadyAppliedAssigneeIds)
                        if(!response.data.alreadyAppliedAssigneeIds.length) {
                            this.alreadyAppliedAssignees = []
                            this.selectedAssignees = []
                            this.selectedTemplate = null
                            this.applyWorkflowErrors = {}
                        }
                        if(type === 'Reapply') {
                            this.$set(this.isReapplyLoadingArray, userId, false)
                        } else {
                            this.$set(this.isDeleteLoadingArray, userId, false)
                        }
                        this.$refs.topProgress.done()
                    }).catch(err => {
                        this.renderAssignedWorkflows()
                        if(err.response.status == 422) {
                            this.applyWorkflowErrors = {
                                ...this.applyWorkflowErrors,
                                assignees: err.response.data.errors.selectedAssignees ? err.response.data.errors.selectedAssignees[0] : null,
                                template: err.response.data.errors.selectedTemplate ? err.response.data.errors.selectedTemplate[0] : null,
                            }
                        } else {
                            this.$toastr.e(err.response.data.message);
                        }
                        this.isAssignWorkflowSubmitButtonLoading = false;
                        if(type === 'Reapply') {
                            this.$set(this.isReapplyLoadingArray, userId, false)
                        } else {
                            this.$set(this.isDeleteLoadingArray, userId, false)
                        }
                        this.$refs.topProgress.done()
                    });
                }
            },
        },
    };
</script>

<template>
    <div class="row mb-2 justify-content-between">
        <vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
        <div class="col-sm-8"></div>
        <div class="col-sm-4">
            <div v-if="isShowAssignButton" class="col-auto float-sm-end d-sm-flex align-items-center">
                <AddButton :onClick="showAssignWorkflowModal" classes="mb-2">Assign Workflow</AddButton>
            </div>
            <div v-if="isShowSearch" class="search-box me-2 mb-2 d-inline-block">
                <div class="position-relative">
                    <div class="input-group">
                        <FormSearchInput
                            v-model='searchValue'
                            type="text"
                            placeholder="Search..."
                            :searchInputTrigger="searchInputTrigger"
                        />
                        <Button 
                            variant="primary"
                            classes='btn-rounded'
                            :onClick="searchFunc"
                            type="button"
                            ref="searchClick"
                        >
                            <i class="bx bx-search-alt mt-1"></i>
                        </Button>
                    </div>
                </div>
            </div>
        </div><!-- end col-->
        <FormModal
            :isShow="isShowAssignWorkflowModal"
            title="Assign Workflow"
            :isButtonLoading="isAssignWorkflowSubmitButtonLoading"
            :isShowSubmitButton="true"
            :isShowCancelButton="true"
            :clickSubmitButton="handleAssignWorkflowSubmit"
            :submitButtonText="assignWorkflowSubmitButtonText"
            @hideModal="hideAssignWorkflowModal"
        >
            <div class="row">
                <div class="col-12">
                    <div class="mb-3">
                        <label>
                            Select Assignees
                            <span class="text-danger">*</span>
                        </label>
                        <MultiSelect
                            v-model="selectedAssignees" 
                            :options="workflowAssignees" 
                            :multiple="true"
                            placeholder="Type & select assignee" 
                            :custom-label="asingeeOptionLabel" 
                            track-by="id"
                            @select="selectAssignee"
                            @remove="removeSelectedAssignees"
                            :class="{
                                'is-invalid': applyWorkflowErrors.assignees
                            }">
                        </MultiSelect>
                        <div
                            v-if="applyWorkflowErrors.assignees"
                            class="invalid-feedback"
                        >
                            {{ applyWorkflowErrors.assignees }}
                        </div>
                    </div>
                    <div
                        v-if="alreadyAppliedAssignees.length"
                        class="table-responsive">
                        <table class="table table-sm">
                            <thead class="table-light">
                                <tr>
                                    <th>Client</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr 
                                    v-for="(item, index) in alreadyAppliedAssignees"
                                    :key="index"
                                >
                                    <td>
                                        <div class="d-flex">
                                            <div class="flex-grow-1 overflow-hidden">
                                                <h5 class="font-size-14 mb-1"><a href="javascript: void(0);" class="text-dark">{{ item.name }}</a></h5>
                                                <p class="text-muted mb-0">{{ item.email }}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <b-button
                                            variant="success"
                                            @click="handleReapplyDeleteWorkflow('Reapply', item.id)"
                                            type="button"
                                            class="ms-1"
                                            title="Click to Reapply"
                                            :disabled="isAssignWorkflowSubmitButtonLoading"
                                            >
                                            {{ isReapplyLoadingArray[item.id] ? 'Loading' : 'Reapply' }}
                                        </b-button>
                                        <b-button
                                            variant="danger"
                                            @click="handleReapplyDeleteWorkflow('Delete', item.id)"
                                            type="button"
                                            class="ms-1"
                                            title="Click to Delete"
                                            :disabled="isAssignWorkflowSubmitButtonLoading"
                                            >
                                            {{ isDeleteLoadingArray[item.id] ? 'Loading' : 'Delete' }}
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-12">
                    <div class="mb-3">
                        <label>
                            Select Workflow Template
                            <span class="text-danger">*</span>
                        </label>
                        <MultiSelect 
                            v-model="selectedTemplate" 
                            :options="workflowTemplates"
                            :custom-label="workflowTemplateOptionLabel"
                            track-by="id" 
                            placeholder="Select Template"
                            @select="selectTemplate"
                            :class="{
                                'is-invalid': applyWorkflowErrors.template,
                            }">
                        </MultiSelect>                     
                        <div
                            v-if="applyWorkflowErrors.template"
                            class="invalid-feedback"
                        >
                            {{ applyWorkflowErrors.template }}
                        </div>
                    </div>
                </div>
            </div>
        </FormModal>
    </div>
</template>